import Vue from 'vue'
import request from '@/common/request.js'; // 全局请求方法
import api from '@/common/api.js'; // 全局API
import uView from "uview-ui";
import filter from '@/filters/index.js'; // 全局过滤器
import condition from './condition.js'; // 引入就行
import globalMixins from "@/mixins/globalMixins.js"
import storage from "../utils/storage/index.js"
import '@/libs/ican-H5Api'
import initMtaRouter from "@/utils/mta/start.js";
import share from "@/utils/share/start.js"

import {
	navBack,
	globalSet,
	getSystemInfo,
	pageJump,
	getUrlInfo,
	numSystemVal,
	isInstallAddons
} from '@/utils/util' // 一些方法
import {
	form
} from '@/utils/validation.js' // 校验方法

export default function start() {
	initMtaRouter()
	condition()
	Vue.prototype.$share = share;
	Vue.prototype.navBack = navBack;
	Vue.prototype.globalSet = globalSet;
	Vue.prototype.getSystemInfo = getSystemInfo;
	Vue.prototype.pageJump = pageJump;
	Vue.prototype.getUrlInfo = getUrlInfo;
	Vue.prototype.isInstallAddons = isInstallAddons;
    Vue.prototype.$api = api;
    Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue();
    Vue.prototype.$http = request;
    Vue.prototype.$form = form;
	Vue.prototype.numSystemVal = numSystemVal
    Vue.use(filter);
	Vue.use(uView);
	Vue.use(globalMixins);
	Vue.use(storage);
}
